import * as React from 'react'

import { styled, spacing } from '@thg-commerce/gravity-theme'
import { isMobileDevice } from '@thg-commerce/gravity-system'

export interface SocialShareIcon {
  title: string
  href: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  mobileOnly?: boolean
}

interface SocialShareProps {
  icons: SocialShareIcon[]
  userAgent: string
  className?: string
}

const Container = styled.ul`
  display: inline-flex;
`

const IconLink = styled.a`
  display: block;
  height: 40px;
  width: 40px;
  border: 2px solid transparent;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.palette.brand.base};
  }

  svg {
    margin: -2px 0 0 -2px;
  }
`
const ListItem = styled.li`
  margin-top: 0;
  padding-right: ${spacing(1)};

  &:last-child {
    padding-right: 0;
  }
`

export const SocialShare = ({
  icons,
  userAgent,
  className,
}: SocialShareProps) => {
  const currentDeviceIsMobile = isMobileDevice(userAgent)
  const renderedIcons = icons.map(
    ({ title, href, icon: Icon, mobileOnly }, index) => {
      const disablePinJs = href.includes('pinterest') || false
      if (mobileOnly && currentDeviceIsMobile) {
        return null
      }
      return (
        <ListItem key={`social-share-link-${index}`} className={className}>
          <IconLink
            title={title}
            href={href}
            aria-label={title}
            rel="noopener noreferrer"
            target="_blank"
            {...(disablePinJs && { 'data-pin-do': 'none' })}
          >
            <Icon />
          </IconLink>
        </ListItem>
      )
    },
  )
  return <Container data-testid="social-share">{renderedIcons}</Container>
}
